import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import HeroSection from "./components/HeroSection";
import HotComicsSection from "./components/HotComicsSection";
import CategoryNavSection from "./components/CategoryNavSection";
import FAQSection from "./components/FAQSection";
import LatestNewsSection from "./components/LatestNewsSection";
import CTASection from "./components/CTASection";
import { faqData, siteInfo } from "@/mocks/homeData";

export default function Home() {
  return (
    <>
      <SEOHead
        title="51漫画 | 51漫画免费版下载与51漫画免费观看 | 云缨巡街漫画免费入口"
        description="51漫画官网 - 提供51漫画免费版下载、51漫画免费在线观看、云缨巡街漫画免费入口。汇聚海量热门漫画资源，支持51漫画APP下载、网页版在线看，为漫画迷打造一站式阅读平台。"
        keywords="51漫画, 51漫画免费版下载, 51漫画免费观看, 云缨巡街漫画, 51漫画网址, 51漫画app下载, 51漫画在线看, 免费51漫画, 51漫画官网版, 51漫画网页版"
        canonicalUrl="https://www.51manhua.com/"
      />

      <SchemaOrg type="organization" data={{
        "@type": "Organization",
        name: siteInfo.name,
        url: "https://www.51manhua.com/",
        description: siteInfo.description,
        foundingDate: siteInfo.established,
        contactPoint: {
          "@type": "ContactPoint",
          email: siteInfo.email,
          contactType: "customer service",
        },
      }} />

      <SchemaOrg type="website" data={{
        "@type": "WebSite",
        name: siteInfo.name,
        url: "https://www.51manhua.com/",
        description: siteInfo.description,
        potentialAction: {
          "@type": "SearchAction",
          target: "https://www.51manhua.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      }} />

      <SchemaOrg type="webpage" data={{
        "@type": "WebPage",
        name: "51漫画 - 首页",
        description: "51漫画免费版下载与在线观看，海量漫画资源一站式平台",
        url: "https://www.51manhua.com/",
        isPartOf: {
          "@type": "WebSite",
          name: siteInfo.name,
        },
      }} />

      <SchemaOrg type="faqpage" data={{
        "@type": "FAQPage",
        mainEntity: faqData.map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.answer,
          },
        })),
      }} />

      <Navbar />

      <main>
        <HeroSection />
        <HotComicsSection />
        <CategoryNavSection />
        <FAQSection />
        <LatestNewsSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}